export function logout() {
  window.location.href = `https://truss-${import.meta.env.VITE_ENVIRONMENT}.auth.${import.meta.env.VITE_REGION}.amazoncognito.com/logout?client_id=${import.meta.env.VITE_COGNITO_CLIENT_ID}&logout_uri=${window.location.origin}/logout`;
}

export function getLogoutUrl() {
  return `https://truss-${import.meta.env.VITE_ENVIRONMENT}.auth.${import.meta.env.VITE_REGION}.amazoncognito.com/logout?client_id=${import.meta.env.VITE_COGNITO_CLIENT_ID}&logout_uri=${window.location.origin}/logout`;
}
